import { AdminList } from "../../../../Components/secure/admin/AdminList"
import { Container } from "semantic-ui-react"

export const Admins = () => {
  return (
    <Container>
      <AdminList />
    </Container>
  )
}